import Page from './signup'

export default Page
